import { render, staticRenderFns } from "./StarRatings.vue?vue&type=template&id=6c1bdd6a&"
import script from "./StarRatings.vue?vue&type=script&lang=js&"
export * from "./StarRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports